import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { styled, css } from 'styled-components';
export const CheckboxContainer = styled.div `
  display: inline-flex;
`;
const Icon = styled.svg `
  visibility: hidden;

  rect {
    fill: ${({ theme }) => theme.colors.main};
  }

  polyline {
    fill: none;
    stroke: ${({ theme }) => theme.colors.main};
    stroke-width: 4px;
  }
`;
const zoomInStyles = css `
  opacity: 1;
  transform: scale(1);
`;
const squareStyles = css `
  &::before,
  &::after {
    content: '';
    transition: all 50ms ease;
    display: block;
    border-radius: 2px;
    width: 14px;
    background-color: ${({ theme }) => theme.colors.main};
    transform: scale(0);
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
  }

  &::before {
    height: 14px;
    left: 2px;
    top: 2px;
    ${({ checked }) => checked && zoomInStyles}
  }

  &::after {
    height: 4px;
    left: 2px;
    top: 7px;
    ${({ $indeterminate }) => $indeterminate && zoomInStyles}
  }
`;
export const StyledCheckbox = styled.div `
  position: relative;
  user-select: none;
  display: inline-block;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  width: ${({ $square }) => ($square ? '20px' : '16px')};
  height: ${({ $square }) => ($square ? '20px' : '16px')};
  background: ${({ disabled, theme }) => (disabled ? theme.colors.grey05_3 : theme.colors.grey00_7)};
  border: 1px solid ${({ theme }) => theme.colors.grey10_1};
  border-radius: 4px;
  transition: all 100ms;
  ${({ disabled, theme }) => disabled &&
    css `
      border-color: ${theme.colors.grey30_3} !important;
    `}

  &:hover {
    border-color: ${({ disabled, theme }) => !disabled && theme.colors.grey70_1};
  }

  ${({ $square }) => $square && squareStyles}
`;
export const HiddenCheckbox = styled.input `
  border: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;

  &:indeterminate + ${StyledCheckbox}, &:checked + ${StyledCheckbox} {
    ${Icon} {
      visibility: visible;
    }
  }
`;
const Checkbox = ({ square, className, checked, disabled, indeterminate, ...props }) => {
    const inputRef = React.useRef(null);
    React.useEffect(() => {
        if (!inputRef.current) {
            return;
        }
        inputRef.current.indeterminate = indeterminate ?? false;
    }, [indeterminate]);
    return (_jsxs(CheckboxContainer, { className: className, "data-test-checked": checked || false, children: [_jsx(HiddenCheckbox, { ref: inputRef, type: 'checkbox', checked: checked, disabled: disabled, ...props }), _jsx(StyledCheckbox, { checked: checked || false, "$square": square, disabled: disabled, "$indeterminate": indeterminate, children: !square && (_jsx(Icon, { viewBox: '0 0 24 24', children: indeterminate ? _jsx("rect", { width: '16', height: '4', x: '4', y: '10' }) : _jsx("polyline", { points: '20 6 9 17 4 12' }) })) })] }));
};
export { Checkbox };
